import client from '@/services/';

const state = () => ({
    all: [],
    one: {}
});

const getters = {
    all: state => state.all,
    one: state => state.one
};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    },
};

const actions = {
    async getAll(cxt, payload) {
        let { data } = await client.get('activiteElection');
        cxt.commit("SET_ALL", data);
        return data;
    },
    async getAllP(cxt, payload = {}) {
        let { data } = await client.get('activiteElection/' + payload);
        cxt.commit("SET_ALL", {
            loaded: true, ...data, number: data.number + 1,
            content: data.content || []
        })
        //cxt.commit("SET_ALL", data);
        return data;
    },
    async getOne(cxt, id) {
        let { data } = await client.get('activiteElection/one/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async create(cxt, payload) {
        let { data } = payload.id ? await client.put('activiteElection/edit/' + payload.id, payload) : await client.post('activiteElection/add', payload);
        cxt.commit("SET_ONE", data);
        if (payload.id) {
            payload.id = null;
        }
        return data;
    },
    async del(cxt, id) {
        let { data } = await client.delete('activiteElection/delete/' + id);
        cxt.commit("SET_ONE", data);
        return data;
    },
    async getActivite(cxt, secteurId) {
        let { data } = await client.get('activiteElection/bySecteur/' + secteurId);
        //cxt.commit("SET_PRODUIT", data);
        return data;
    },
    async requeteElection(cxt, payload = { page: 1, regionId: '', secteurId: '', activiteElectionId: '' }) {
        let { data } = await client.get(`/activiteElection/find/${payload.page}`, { params: { page: payload.page, regionId: payload.regionId, secteurId: payload.secteurId, activiteElectionId: payload.activiteElectionId } });
        return data;
    },
    async exportRequeteElection(cxt, payload = { regionId: '', secteurId: '', activiteElectionId: '' }) {
        let response = await client.get(`/activiteElection/find/export/`, {
            params: {
                regionId: payload.regionId || '',
                secteurId: payload.secteurId || '',
                activiteElectionId: payload.activiteElectionId || ''
            }
        });
        return response;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
